<script lang="ts">
  import { Col, Image } from "sveltestrap";
  import { Status } from "../../../../utils/Constant/Constant";
  import Card from "../../../Core/Card.svelte";
  import PeopleList from "./PeopleList.svelte";
  let imgPath: string = "/assets/images/user";
</script>

<Col class="call-chat-sidebar">
  <Card cardBodyprops="chat-body">
    <div slot="contentbody">
      <div class="chat-box">
        <div class="chat-left-aside">
          <div class="media">
            <Image
              class="rounded-circle user-image"
              src="{imgPath}/12.png"
              alt=""
            />
            <div class="about">
              <div class="name f-w-600">{'Mark Jecno'}</div>
              <div class="status">{Status}</div>
            </div>
          </div>
          <PeopleList />
        </div>
      </div>
    </div>
  </Card>
</Col>
